import _ from './source/helper/HelperFunctions';

(function($) {
	$(document).ready(() => {
		_.toArray(document.querySelectorAll('.owl-carousel')).forEach(car => {
			$(car).owlCarousel({
				center: true,
				loop: true,
				nav: true,
				items: 1,
				stagePadding: 50,
				responsive: {
					1100: {
						items: 1,
						stagePadding: 440
					}
				}
			})

			let activeSlideText = $("<div class='active-text'></div>");

			$(activeSlideText).insertBefore($(car).parent().find('.btn-green'));

			activeSlideText = $(car).parent().find('.active-text');

			fixActiveText();
			fixNeighbour();

			$(car).on('changed.owl.carousel', () => {
				setTimeout(() => {
					fixActiveText();
					fixNeighbour();
				}, 100);
			})

			function fixActiveText() {
				$(activeSlideText).html($(car).find('.center.owl-item .content').html());
			}

			function fixNeighbour() {
				_.removeClassFromAll($(car).find('.owl-item'), 'neighbour');
				
				let currentlyActive = $(car).find('.center');
				currentlyActive.prev().addClass('neighbour');
				currentlyActive.next().addClass('neighbour');
			}
		})
	})
})(window.jQuery)